import React, { useEffect, useState, useCallback } from 'react';
import { statusLojaService } from '../services/api';

const ALERT_LABELS = {
  transito: {
    icon: 'fa-truck',
    label: 'Mercadoria em Trânsito',
    texto: (n) => `${n} MERCADORIA${n > 1 ? 'S' : ''} EM TRÂNSITO PENDENTE${n > 1 ? 'S' : ''}`,
  },
  notas_pendentes: {
    icon: 'fa-file-invoice',
    label: 'Notas Pendentes',
    texto: (n) => `${n} NOTA${n > 1 ? 'S' : ''} PENDENTE${n > 1 ? 'S' : ''}`,
  },
  caixas_cb_pendentes: {
    icon: 'fa-box',
    label: 'Caixas CB',
    texto: (n) => `${n} CAIXA${n > 1 ? 'S' : ''} CB PENDENTE${n > 1 ? 'S' : ''}`,
  },
  pedidos_clientes: {
    icon: 'fa-cart-shopping',
    label: 'Pedidos Cliente',
    texto: (n) => `${n} PEDIDO${n > 1 ? 'S' : ''} DE CLIENTE PENDENTE${n > 1 ? 'S' : ''}`,
  },
  transferencias: {
    icon: 'fa-right-left',
    label: 'Transferências',
    texto: (n) => `${n} TRANSFERÊNCIA${n > 1 ? 'S' : ''} PENDENTE${n > 1 ? 'S' : ''}`,
  },
};

const StatusLojaAlerts = ({ lojaId, onOpenWindow }) => {
  const [alertas, setAlertas] = useState(null);
  const [loading, setLoading] = useState(false);

  const carregar = useCallback(async () => {
    if (!lojaId) return;
    setLoading(true);
    try {
      const data = await statusLojaService.verificarStatus(lojaId);
      setAlertas(data?.alertas || null);
    } catch (e) {
      console.warn('Erro ao buscar status da loja:', e?.message);
      setAlertas(null);
    } finally {
      setLoading(false);
    }
  }, [lojaId]);

  useEffect(() => {
    carregar();
    const intervalo = setInterval(carregar, 60_000); // refaz a cada 60s
    return () => clearInterval(intervalo);
  }, [carregar]);

  // Coleta todos os alertas com tem_alerta=true
  const itens = alertas
    ? Object.entries(alertas)
        .filter(([, alerta]) => alerta && alerta.tem_alerta)
        .map(([chave, alerta]) => ({
          chave,
          ...ALERT_LABELS[chave],
          mensagem: alerta.mensagem,
          nivel: alerta.nivel,
          quantidade:
            alerta.quantidade_documentos ||
            alerta.quantidade_notas ||
            alerta.quantidade_caixas ||
            alerta.quantidade_pedidos ||
            alerta.quantidade ||
            0,
        }))
        .filter((item) => item.label)
    : [];

  const handleClick = (chave) => {
    if (!onOpenWindow) return;
    const mapa = {
      transito: 'transito',
      notas_pendentes: 'notas',
      caixas_cb_pendentes: 'caixas',
      pedidos_clientes: 'clienteRetira',
      transferencias: 'transferencias',
    };
    const id = mapa[chave];
    if (id) onOpenWindow(id);
  };

  return (
    <div
      className={`status-loja-alerts ${itens.length === 0 ? 'is-empty' : ''}`}
      role="status"
      aria-live="polite"
    >
      <div className="status-loja-alerts-list">
        {itens.length === 0 ? (
          <span className="status-loja-alert-empty" aria-hidden="true">&nbsp;</span>
        ) : (
          itens.map((item) => {
            const texto = item.texto ? item.texto(item.quantidade) : item.mensagem;
            return (
              <button
                key={item.chave}
                type="button"
                className={`status-loja-alert-item nivel-${item.nivel || 'vermelho'}`}
                onClick={() => handleClick(item.chave)}
                title={item.mensagem}
              >
                <i className={`fas ${item.icon}`}></i>
                <span className="status-loja-alert-text-msg">{texto}</span>
              </button>
            );
          })
        )}
      </div>
    </div>
  );
};

export default StatusLojaAlerts;
